// extracted by mini-css-extract-plugin
export default {"block":"custom-option-label_block__N0ohB","icons":"custom-option-label_icons__0oSGh","name":"custom-option-label_name__CDL4r"};